import { render, staticRenderFns } from "./NewPlayList.vue?vue&type=template&id=b56e7d56"
import script from "./NewPlayList.vue?vue&type=script&lang=js"
export * from "./NewPlayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports